import React from 'react'
import { connect } from 'react-redux'
import { doGetAutoNumberSequenceList } from '../../reducers/actions'
import AutoNumberSequenceDiv from './AutoNumberSequenceDiv'
class AutoNumberSequenceListDiv extends React.Component {
  state = {}
  componentDidMount = () => {
    this.handleInitAutoNumberSequence()
  }
  handleInitAutoNumberSequence = () => {
    const { onSave, onClose, dispatch, AutoNumberID } = this.props
    dispatch(doGetAutoNumberSequenceList({
      id: AutoNumberID,
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ initValues基本信息 })
        }
      }
    }))
  }
  handleAddAutoNumberSequence = (data) => {
    const { AutoNumberID } = this.props
    Tyan.pubForm.showDialog('起始编号设置', props => <AutoNumberSequenceDiv {...props} id={-1} AutoNumberID={AutoNumberID} onSave={this.handleInitAutoNumberSequence} />)
    this.setState({})
  }

  handleEditAutoNumberSequence = (data) => {
    const { AutoNumberID } = this.props
    Tyan.pubForm.showDialog('起始编号设置', props => <AutoNumberSequenceDiv {...props} id={data.id} AutoNumberID={AutoNumberID} onSave={this.handleInitAutoNumberSequence} />)
    this.setState({})
  }

  handlerClose = () => {
    const { onClose } = this.props
    onClose && onClose()
  }

  fieldset模板 = () => {
    return [{
      _grid: '', name: '模板', rowNumbers: true, minRows: 5,
      columns: [
        { _text: '前缀', name: '前缀', minWidth: 300, flex: 1 },
        { _text: '编号', name: '编号', minWidth: 300, flex: 1 },
      ],
      onDoubleTap: this.handleEditAutoNumberSequence,
    }]
  }

  render = () => {
    const {showBody:Body} = this.props

    return <Body data={this} maxWidth={1200}
      controls={
        [
          { _button: '添加', handler: this.handleAddAutoNumberSequence },
          { _button: '关闭', handler: this.handlerClose },
        ]}
      fieldsets={[
        { title: '', name: '基本信息', _fieldset: this.fieldset模板(), flex: 1 },
      ]}
    />
  }
}

export default connect()(AutoNumberSequenceListDiv)